import { ReactNode } from 'react';

interface ObjectStickyToolbarProps {
  children: ReactNode;
}

export const ObjectStickyToolbar = ({ children }: ObjectStickyToolbarProps) => <>{children}</>;
